module.exports = __webpack_public_path__ + "img/main_2_2_2_2_1.651e9e8f.png";